// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".per-avatar-area[data-v-39c8bb06]{width:40px;height:40px;position:relative}.per-avatar-area .per-avatar[data-v-39c8bb06]{width:100%;height:100%;background-color:#f5f5f5;border-radius:50%;position:absolute}", ""]);
// Exports
module.exports = exports;
